import Image from 'next/image'

import { Container } from '~/components'

import * as styles from './Header.css'

import vaduzLogo from '~/assets/vaduz-logo.svg'
import vpbankLogo from '~/assets/vpbank-logo.svg'

type Props = {
  title: string
}

export function Header({ title }: Props) {
  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.content}>
          <span className={styles.info}>{title}</span>
          <div className={styles.logos}>
            <a href="https://www.vpbank.com" target="_blank" rel="noreferrer" className={styles.logo}>
              <Image src={vpbankLogo} alt="VP Bank AG" width={134} height={44} />
            </a>
            <a href="https://www.vaduz.li" target="_blank" rel="noreferrer" className={styles.logo}>
              <Image src={vaduzLogo} alt="Gemeinde Vaduz" width={171} height={13} className={styles.logoVaduz} />
            </a>
          </div>
        </div>
      </Container>
    </header>
  )
}
